import { useMemo } from 'react';
import { AbTestName, getExperimentByName } from 'utils/abTests';
import { useExperimentsContext } from '~/context/ExperimentsContext';

import { WlWindow } from '../../typings/globals/cordova';

declare const window: WlWindow;

function useExperiment(experimentName: AbTestName) {
  const { state, actions } = useExperimentsContext();
  const experimentId = getExperimentByName(experimentName)?.id;
  actions.assignExperimentVariant(experimentName);

  const setVariant = (variant: number) => {
    return actions.setExperimentVariant(experimentId, variant);
  };

  const assignedVariant = useMemo(() => {
    if (window.Cypress) {
      return 0;
    }
    return state.experiments.find(({ id }) => id === experimentId)
      ?.assignedVariant;
  }, [state.experiments, experimentId]);

  return {
    assignedVariant,
    actions: {
      setVariant,
    },
  };
}

export default useExperiment;
